import CommonConfirmModal from ".";
import WithFnModalComponent from "../FunctionModal";

export const ConfirmModal = WithFnModalComponent(
  CommonConfirmModal,
  "confirmModal"
);
export function customConfirm(
  title: string,
  obj?: { cancel: string; confirm: string }
) {
  return new Promise((resolve, reject) => {
    ConfirmModal(
      Object.assign(
        {
          title: title,
          onOk: (isShowAgin: boolean) => {
            resolve(true);
          },
          onCancel: (isShowAgin: boolean) => {
            resolve(false);
          },
        },
        obj ? obj : {}
      )
    );
  });
}
